import { Badge } from '@/shared/ui/badge'
import type { WebRequiredCompliance } from '@/shared/types/web'

interface Props {
  record: Pick<
    WebRequiredCompliance,
    'isNonCompliant' | 'complianceReviewStatusId' | 'complianceValueLabel' | 'value'
  >
}

const ComplianceStatusBadge = ({ record }: Props) => {
  if (record.isNonCompliant) {
    return <Badge variant="destructive">{record.complianceValueLabel}</Badge>
  }

  if (record.value === 100) {
    return <Badge variant="secondary">{record.complianceValueLabel}</Badge>
  }

  if (record.value > 0) {
    return <Badge variant="warning">{record.complianceValueLabel}</Badge>
  }

  return <Badge variant="outline">{record.complianceValueLabel}</Badge>
}

export default ComplianceStatusBadge
